import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withModifiers as _withModifiers, createElementBlock as _createElementBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-41e31c2e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "h-[3.75rem] bg-mainDark" }
const _hoisted_2 = { class: "container px-0 lg:pl-7 lg:pr-4 mx-auto flex justify-between items-center h-full" }
const _hoisted_3 = { class: "flex items-center h-full" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "flex items-center whitespace-nowrap" }
const _hoisted_6 = ["src"]
const _hoisted_7 = {
  key: 0,
  class: "fixed bottom-0 pb-4 px-4 z-10 flex w-full justify-center transform-gpu sm:hidden"
}

import { computed, onMounted, watch, ref } from 'vue'
import { IonHeader, IonToolbar, loadingController } from '@ionic/vue'
import { Order } from '@/models/order'
import { useStore } from 'vuex'
import { State } from '@/store'
import { useRoute, useRouter } from 'vue-router'
import { useI18n } from 'vue-i18n'
import { useEvents } from '@/composables/events'
import ChangeLocale from '@/components/ChangeLocale.vue'
import LogoutButton from '@/components/LogoutButton.vue'
import WebsiteLink from '@/components/WebsiteLink.vue'
import { useGrid } from 'vue-screen'
import { useEventHandlers } from '@/composables/eventHandlers'
import { useGWAnalytics } from '@/plugins/analytics'


export default /*#__PURE__*/_defineComponent({
  __name: 'GwHeader',
  setup(__props) {

const { openModalEvent, modalEventBus } = useEvents()
const store = useStore<State>()
const { t } = useI18n()
const router = useRouter()
const route = useRoute()
const grid = useGrid('tailwind')
const { vAnalyticsClick } = useGWAnalytics()
const { clickDelay } = useEventHandlers()

const creatingNewOrder = computed(() => store.state.creatingNewOrder)
const isLoggedIn = computed(() => store.getters.isLoggedIn)

const cancelNewOrder = () => {
	store.dispatch('finishNewOrder')
	router.push('/zoznam')
}

const homeOrRefresh = async () => {
	if (route.fullPath === '/') {
		const loading = await loadingController.create({ spinner: 'crescent' })
		loading.present()
		await new Promise(resolve => setTimeout(() => resolve(true), 500))
		router.go(0)
	}
	else {
		modalEventBus.emit('close', { type: 'menu' })
		router.push('/')
	}
}

const menuOpen = ref(false)
const toggleMenu = () => {
	if (creatingNewOrder.value) return cancelNewOrder()
	menuOpen.value ? modalEventBus.emit('close', { type: 'menu' }) : openModalEvent('menu')
}
modalEventBus.on(
	(event, payload) => { 
		if (payload?.type !== 'menu') return
		if (event === 'open') menuOpen.value = true
		else if (event === 'close') menuOpen.value = false
	}
)
const openLogin = () => {
	modalEventBus.emit('close', { type: 'menu' })
	openModalEvent('login')
}

const newOrder = async () => {
	store.dispatch('startNewOrder', new Order())
	await router.push('/')

	const unwatch = watch(route, () => {
		store.dispatch('finishNewOrder')
		unwatch()
	})
}

/* eslint-disable @typescript-eslint/no-var-requires */
const image = require('@/assets/GWLogoWhite.png')
const toolbarRef = ref<any>(null)
onMounted(() => {
	const observer = new MutationObserver((mutations,) => {
		for (const mutation of mutations) {
			if (mutation.attributeName === 'class' && (mutation.target as HTMLElement).classList.contains('toolbar-segment')) {
				(mutation.target as HTMLElement).classList.remove('toolbar-segment')
			}
		}
	})
	observer.observe(toolbarRef.value.$el, { attributes: true })
})

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(IonHeader), { class: "h-[60px]" }, {
      default: _withCtx(() => [
        _createVNode(_unref(IonToolbar), {
          ref_key: "toolbarRef",
          ref: toolbarRef,
          class: "[--padding-end:.75rem] [--padding-start:.625rem] [--padding-top:0] [--padding-bottom:0]"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("img", {
                    class: "h-10 cursor-pointer mr-4",
                    src: _unref(image),
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (homeOrRefresh()))
                  }, null, 8, _hoisted_4),
                  (_unref(grid).breakpoint && _unref(grid).breakpoint !== 'sm' && isLoggedIn.value && !creatingNewOrder.value)
                    ? _withDirectives((_openBlock(), _createBlock(_component_router_link, {
                        key: 0,
                        class: "text-13 text-white font-semibold my-5",
                        to: "/zoznam"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(t)('order_list_title')), 1)
                        ]),
                        _: 1
                      })), [
                        [_unref(vAnalyticsClick), _unref(route)]
                      ])
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_5, [
                  (_unref(grid).breakpoint && _unref(grid).breakpoint !== 'sm' && isLoggedIn.value && !creatingNewOrder.value)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createVNode(LogoutButton, { class: "text-13 text-white font-normal mx-5 my-5" }),
                        _withDirectives((_openBlock(), _createElementBlock("button", {
                          class: "gw-button -primary -sm mr-4 sm:mr-0 hidden sm:block",
                          onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_unref(clickDelay)(newOrder)), ["prevent"]))
                        }, [
                          _createTextVNode(" + " + _toDisplayString(_unref(t)('create_new_order')), 1)
                        ])), [
                          [_unref(vAnalyticsClick), _unref(route)]
                        ])
                      ], 64))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        (_unref(grid).breakpoint && _unref(grid).breakpoint !== 'sm' && isLoggedIn.value && creatingNewOrder.value)
                          ? _withDirectives((_openBlock(), _createElementBlock("a", {
                              key: 0,
                              class: "text-13 text-white font-normal mx-5 my-5",
                              href: "#",
                              onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_unref(clickDelay)(cancelNewOrder)), ["prevent"]))
                            }, [
                              _createTextVNode(_toDisplayString(_unref(t)('cancel')), 1)
                            ])), [
                              [_unref(vAnalyticsClick), _unref(route)]
                            ])
                          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              _createVNode(WebsiteLink, { class: "hidden sm:inline text-13 text-white font-normal mx-5 my-5" }),
                              (!isLoggedIn.value)
                                ? _withDirectives((_openBlock(), _createElementBlock("button", {
                                    key: 0,
                                    class: "gw-button -primary -sm mr-4 sm:mr-0",
                                    onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_unref(clickDelay)(openLogin)), ["prevent"]))
                                  }, [
                                    _createTextVNode(_toDisplayString(_unref(t)('log_in')), 1)
                                  ])), [
                                    [_unref(vAnalyticsClick), _unref(route)]
                                  ])
                                : _createCommentVNode("", true)
                            ], 64))
                      ], 64)),
                  (_unref(grid).breakpoint && _unref(grid).breakpoint !== 'sm' && (!isLoggedIn.value || !creatingNewOrder.value))
                    ? (_openBlock(), _createBlock(ChangeLocale, { key: 2 }))
                    : _createCommentVNode("", true),
                  (!_unref(grid).breakpoint || _unref(grid).breakpoint === 'sm')
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 3,
                        class: "w-10 h-10 p-2 justify-center items-center inline-flex cursor-pointer",
                        onClick: toggleMenu
                      }, [
                        _createElementVNode("img", {
                          class: "w-6 h-6 relative",
                          src: require(`@/assets/${(menuOpen.value || (isLoggedIn.value && creatingNewOrder.value)) ? 'x-close' : 'menu'}.svg`)
                        }, null, 8, _hoisted_6)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ]),
          _: 1
        }, 512)
      ]),
      _: 1
    }),
    (isLoggedIn.value && !creatingNewOrder.value && _ctx.$route.name !== 'Order')
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createElementVNode("button", {
            class: "gw-button -primary sm:w-auto px-6 mr-0",
            onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_unref(clickDelay)(newOrder)), ["prevent"]))
          }, " + " + _toDisplayString(_unref(t)('create_new_order')), 1)
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})